import React, { createContext, useContext } from 'react';
import { AppState } from './AppState';

const AppStateContext = createContext<AppState | null>(null);

export const AppStateProvider: React.FC<{ 
  appState: AppState;
  children: React.ReactNode 
}> = ({ appState, children }) => (
  <AppStateContext.Provider value={appState}>
    {children}
  </AppStateContext.Provider>
);

export const useAppState = (): AppState => {
  const appState = useContext(AppStateContext);
  if (!appState) {
    throw new Error('useAppState must be used within AppStateProvider');
  }
  return appState;
};

// Convenience hooks for common access patterns
export const useRootStore = () => useAppState().rootStore;
export const useUserState = () => useAppState().userState;
export const useDsManager = () => useAppState().userState?.dsManager;
export const useMobileNavController = () => useAppState().mobileNavController;
export const useServiceRegistry = () => useAppState().getServiceRegistry();
export const useRouter = () => useAppState().routerService;
export const useFileProvider = () => useAppState().userState?.fileProvider;
export const useAuthService = () => useAppState().getServiceRegistry().getAuthService();
export const useDataClientService = () => useAppState().getServiceRegistry().getDataClientService();